import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Outlet,
  useLocation,
} from 'react-router-dom';
import './App.css';
import './index.css';

import braclet from './Assets/braclet.png';
import earing from './Assets/earring.png';
import necklace from './Assets/necklace.png';
import mens from './Assets/mens.png';
import anklet from './Assets/anklet.png';
import custom from './Assets/custom.png';
import ScrollToTop from './Util/ScrollToTop'
// Your actual Bracelet page
import Bracelet from './pages/Braclet';
import Earring from './pages/Earrings';
import Necklaces from './pages/Necklaces';
import Mens from './pages/Mens';
import Anklets from './pages/Anklets';
import Custom from './pages/Custom';



function Layout() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const hero = document.querySelector('.hero-modern');

    const handleScroll = () => {
      if (!hero) return;
      const heroRect = hero.getBoundingClientRect();
      const heroIsOutOfView = heroRect.bottom < 0;
      setIsScrolled(heroIsOutOfView);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [location]);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <>
      {/* HEADER – always fixed at the very top */}
      <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container nav">
          <div className="logo">JoBeads</div>

          <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link>
            <Link to="/bracelets" onClick={() => setIsMenuOpen(false)}>Bracelets</Link>
            <Link to="/earrings" onClick={() => setIsMenuOpen(false)}>Earrings</Link>
            <Link to="/necklaces" onClick={() => setIsMenuOpen(false)}>Necklaces</Link>
            <Link to="/mens" onClick={() => setIsMenuOpen(false)}>Mens</Link>
            <Link to="/anklets" onClick={() => setIsMenuOpen(false)}>Anklets</Link>
            <Link to="/custom" onClick={() => setIsMenuOpen(false)}>Custom</Link>
          </div>

          <div
            className={`hamburger ${isMenuOpen ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </header>

      {/* Page content (Home, Bracelet page, etc.) goes here */}
      <Outlet />

      {/* FOOTER */}
      <footer className="footer">
        <div className="container">
          © 2025 JoBeads • Handmade in small batches with love
        </div>
      </footer>
    </>
  );
}

// Home Page – exactly your original design
function Home() {
  return (
    <>
      <section id="home" className="hero-modern">
        <div className="hero-overlay"></div>
        <div className="hero-content-modern">
          <p className="hero-subtitle">Limited drops • Hand-strung in studio</p>
          <h1 className="hero-title">
            Beads<br />that feel<br />like you
          </h1>
          <div className="hero-ctas">
            <Link to="/bracelets" className="btn btn-primary">Shop New Arrivals</Link>
            <Link to="/bracelets" className="btn btn-ghost">View All →</Link>
          </div>
        </div>
        <div className="floating-bead bead-1"></div>
        <div className="floating-bead bead-2"></div>
        <div className="floating-bead bead-3"></div>
      </section>

      <section id="collection" className="collection">
        <div className="container">
          <h2 className="section-title">JoBeads Collection</h2>
          <div className="grid">
            {[
              { name: "Bracelets", img: braclet, path: "/bracelets" },
              { name: "Earrings", img: earing, path: "/earrings" },
              { name: "Necklace", img: necklace, path: "/necklaces" },
              { name: "Mens", img: mens, path: "/mens" },
              { name: "Anklets", img: anklet, path: "/anklets" },
              { name: "Custom", img: custom, path: "/custom" },
            ].map((item) => (
              <Link key={item.name} to={item.path}>
                <div className="card">
                  <div
                    className="card-img"
                    style={{ backgroundImage: `url(${item.img})` }}
                  ></div>
                  <div className="card-content">
                    <h3>{item.name}</h3>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section id="about" className="about">
        <div className="container">
          <h2 className="section-title">Crafted with Soul</h2>
          <p>
            Each piece begins with a single bead — chosen not just for beauty, but for the story it carries.  
            From our quiet studio, every necklace, bracelet, and earring is hand-strung with care, 
            designed to be cherished for generations.
          </p>
        </div>
      </section>

      <section id="contact" className="cta">
        <div className="container">
          <h2 style={{ color: 'white', lineHeight: '3.5rem' }}>
            Find Your Forever Piece
          </h2>
          <p>Custom commissions warmly welcomed. Let’s create something that feels like you.</p>
          <div className="cta-buttons">
            <a href="mailto:jo@jobeaddsjewelry.com" className="btn btn-primary">
              Email Us
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

// Main App – wrapped in Router
function App() {
  return (
    <>
  <ScrollToTop /> 
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="bracelets" element={<Bracelet />} />
          <Route path="earrings" element={<Earring />} />
          <Route path="necklaces" element={<Necklaces />} />
          <Route path="mens" element={<Mens />} />
          <Route path="anklets" element={<Anklets />} />
          <Route path="custom" element={<Custom />} />
        </Route>
      </Routes>
</>
  );
}

export default App;


